/**
 * Shared canvas helper for building linear gradients across the PIXI color graphics (BoxGraphic,
 * CircleGraphic) and the canvas text graphics (TextDynamicBoxRenderer, TextDynamicCircleRenderer).
 *
 * Gradients are defined by a start and end point in normalized (0..1) shape coordinates — see the
 * GradientPoint model class. Callers map their normalized points onto the shape's bounding box and
 * pass absolute canvas pixels here.
 */

export type GradientPointCoords = { x: number; y: number };

export const createLinearGradient = (
    context: CanvasRenderingContext2D,
    {
        startX,
        startY,
        endX,
        endY,
        startStop,
        endStop,
    }: {
        startX: number;
        startY: number;
        endX: number;
        endY: number;
        startStop: string;
        endStop: string;
    },
): CanvasGradient => {
    const gradient = context.createLinearGradient(startX, startY, endX, endY);
    gradient.addColorStop(0, startStop);
    gradient.addColorStop(1, endStop);
    return gradient;
};
